import { Dienststelle } from '../module/dienststelle';
import { ChangeDetectorRef, Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import {
  BikeCategory,
  BikeCategoryExtendedOptions,
} from '../module/BikeCategory';

@Injectable({
  providedIn: 'root',
})
export class DataSharingService {
  anzahlKinder = 0;
  bikeCategory: BikeCategory | number = 0;
  constructor() {
    this.selectedDate = new Date();
    const ds = localStorage.getItem('DsCode');
    if (ds) {
      this.dsCode = ds;
      this.bikeCategory = this.isVivantes() ? BikeCategory.OTHER : 0;
    }
  }
  public ldList = [
    { value: 24, display: '24 Monate' },
    { value: 30, display: '30 Monate' },
    { value: 36, display: '36 Monate' },
  ];

  public dienststelle: Dienststelle;
  public dsCode = '';
  public currInfo = '';
  public bArt = 1;
  public stKlasse = 1;
  public pkvValue = 0;
  public kaufpreis = 3500.59;
  public bruttoKaufUVP = 0;
  public modusErweitert = false;
  public bruttogehalt = 3000.99;
  public kinderValue = 0;
  public kircheValue = true;
  public radFahrSchutz = true;
  public olderThan23 = false;
  public pvAnteil = 0;
  public leasingDuration = 36;

  // TODO rename or optimize
  public rvValue = true;
  public kvValue = 'gkv';
  public rsValue = 14.6;
  public zusatzValue = 2.5;
  public selectedDate: Date;
  public showFairbetrag = true;
  public inspectionDisabled = false;
  dataSubject = new BehaviorSubject<string>(''); // Initialize with an empty string or any default value
  data$ = this.dataSubject.asObservable();
  inputChanged = new BehaviorSubject<any>(true); // Initialize with an empty string or any default value
  changes$ = this.inputChanged.asObservable();
  toggleInfo(infoType: string): void {
    this.currInfo = this.currInfo === infoType ? '' : infoType;
  }
  get useNetBikePrice(): boolean {
    const affectedServices = [
      'Mie-2023',
      'Din-2023',
      'Sta-2023',
      'Eic-2023',
      'Hro-2022',
      'Gar-2023',
      'Met-2023',
      'Wdn-2023',
      'Swa-2023',
      'Lkb-2023',
      'Ein-2023',
      'Bre-2023',
      'Oyt-2023',
      'Dül-2023',
      'Lud-2023',
    ];
    return affectedServices.includes(this.dsCode);
  }

  update(newData: string) {
    this.dsCode = newData.trim();
    if (this.dsCode !== '') {
      localStorage.setItem('DsCode', this.dsCode);
    }
    this.dataSubject.next(this.dsCode);
  }

  updateDienststelle(ds: Dienststelle): void {
    // TODO add in new structure
    this.dienststelle = ds;
    if (this.dsCode.includes('-5')) {
      // Arbeitnehmer als standard
      this.bArt = 2;
    }
    this.ldList = [];
    // TODO Check if the  this.dienststelle.leasingDuration is set correctly
    const ld = this.dienststelle.leasingDuration.split(';');
    this.ldList = ld.map((erg) => {
      return { value: Number(erg), display: erg + ' Monate' };
    });

    this.leasingDuration = this.getMaxLeasingDauer(ld);
    this.bikeCategory = this.isVivantes() ? BikeCategory.OTHER : 0;
  }

  showDiv(divVal: string): void {
    if (this.currInfo !== divVal) {
      this.currInfo = divVal;
    } else {
      this.currInfo = '';
    }
  }

  public isVivantes(): boolean {
    return this.dsCode.startsWith('Viv-');
  }

  public getKaufpreis(): number {
    if (this.useNetBikePrice) {
      return this.kaufpreis / 1.19;
    }
    return this.kaufpreis;
  }

  private getMaxLeasingDauer(ld: string[]): number {
    const numberArray = ld
      .map((str) => Number(str))
      .filter((num) => !isNaN(num));
    // Find the maximum number in the array
    return Math.max(...numberArray);
  }
}
